import { render, staticRenderFns } from "./MasterPengurusHistory.vue?vue&type=template&id=4240149f&"
import script from "./MasterPengurusHistory.vue?vue&type=script&lang=js&"
export * from "./MasterPengurusHistory.vue?vue&type=script&lang=js&"
import style0 from "./MasterPengurusHistory.vue?vue&type=style&index=0&id=4240149f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports